export default "__VITE_ASSET__siEREXzy__"